import Framework from '@yld/framework'
import YunIcon from '@yld/yun-icon'
// import VueBMap from 'vue-bmap-gl'
import 'vue-bmap-gl/dist/style.css'
import './style/index.scss'

const serverConfig = require('../serverConfig.json')

const app = new Framework({
  serverConfig
})

app.use(YunIcon)
// app.use(VueBMap)
// VueBMap.initBMapApiLoader({
//   ak: 'ZHGeKB7kGNGAqOAxo41mijEvWTqGaemL',
//   // 默认百度 sdk 版本为 1.0
//   v: '1.0'
// })

app.start()
